import React, { useContext, useMemo, useState } from 'react';
import {
  getDispositionTypeOnAPIFormat,
  getTernaryValue,
  isEmptyEvery,
  checkIfStoreShutDown,
  getUserType,
} from 'common/utilities/utils';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { useDispatch, useSelector } from 'react-redux';
import { UserOrderContext } from 'context/context';
import FoodItemListHandlers from 'organisms/CartPage/AU/Presentation/ReusableComponents/FoodItemListHandlers';
import { useHistory } from 'react-router-dom';
import { QuantityModifier } from 'molecules/QuantityModifier';
import FoodItemListCard from 'organisms/CartPage/AU/Presentation/ReusableComponents/FoodItemListCard';
import CartEditNotification from 'organisms/CartPage/AU/Presentation/ReusableComponents/CartEditNotification';
import CartPagePromosItem from 'organisms/CartPage/AU/Presentation/ReusableComponents/CartPagePromosItem';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { LOCAL_STORAGE_KEYS } from 'common/constants/SharedConstants';
import { ReactSVG } from 'react-svg';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import AlertFormInsideModel from 'molecules/Alert';
import AlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import ImageComponent from 'atoms/Image';
import { useShowToastMsg } from 'organisms/CartPage/CustomHooks/foodItemListCustomHooks';
import { ContainedButton } from 'atoms/Buttons';
import { toast } from 'react-toastify';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { isEmpty } from 'lodash';
import { getObjectFromLocalStorage } from 'molecules/DynamicMenuAlert/AU/Utils/DynamicMenuAlertUtils';
const {
  BACK_TO_MENU,
  VIEW_ALL_PROMOS,
  PROMO_REMOVE_CONFIRMATION,
  YES_REMOVE,
  CANCEL,
  MAX_ORDER_PROMO,
  CHECKOUT_UNAVAILABLE_AT_STORE,
  UNAVAILABLE_ITEMS,
  REMOVE_ALL_UNAVAILABLE_TEXT,
} = TRANSLATE_MAPPING_KEY;
const findPromoProductItem = (removableItem, contentData) => {
  let itemToBeRemoved = '';
  for (let i in removableItem?.itemPromo) {
    let itemPromo = removableItem?.itemPromo[i];
    itemToBeRemoved = contentData?.find(
      foodItem => foodItem.isProductPromo && foodItem.foodItemId === itemPromo.itemId,
    );
    if (itemToBeRemoved) {
      itemToBeRemoved.discountAmount = removableItem?.amount;
      break;
    }
  }
  return itemToBeRemoved;
};

export const getQuantityModifier = (
  item,
  ITEM_QUANTITY,
  QUANTITY_ACTION,
  itemQuantityHandler,
  maxItemCountPerLineItem,
  paymentDiscountAmounts
) => {
  return (
    item?.name !== START_ORDER_CONSTANTS?.PAPER_BAG_FEE &&
    (!item?.toRemove ? ( //removing isAddedFromCoupon because it's not required in SOPAC
      <QuantityModifier
        itemQuantity={ITEM_QUANTITY}
        itemCount={item?.quantity}
        updateItemQuantity={itemQuantityHandler}
        quantityAction={QUANTITY_ACTION}
        item={item}
        itemName={item?.foodName}
        maxItemCountPerLineItem={item?.maxQuantity || maxItemCountPerLineItem}
        hideChild={true}
        cartItemCount={1}
        data-testid='quantity-modifier-item'
        paymentDiscountAmounts={paymentDiscountAmounts}
      />
    ) : null)
  );
};

const FoodItemList = props => {
  const {
    contentData = [],
    cartSummary,
    addHope,
    carryBag,
    maxItemCountPerLineItem,
    isMobile,
    currencySymbol,
    loggedIn,
    storesWithStatus,
    isRemoveItemLoading,
  } = props;
  const { discountAmounts, removedAddOnItems, paymentDiscountAmounts} = cartSummary;
  const { CART_FOOD_LIST_ITEM, QUANTITY_ACTION } = CART_PAGE_CONSTANTS;
  const { ITEM_QUANTITY, REMOVE } = CART_FOOD_LIST_ITEM;
  const { ViewDetailsArrowBlack, CartError } = IMAGE_PATH;
  const { categories = [] } = useSelector(data => data.menuReducer.data || {});
  const flatResponse = useSelector(({ menuReducer: { flatResponse } }) => flatResponse);
  const { productMapByItemId = {} } = flatResponse ?? {};
  const tenantReducer = useSelector(data => data.tenantReducer || {});
  const userParams = useSelector(data => data.appStateReducer.userStatus);
  const userType = getUserType(userParams?.localized, userParams?.loggedIn);
  const { tenantId, currencyShortName, componentOptions } = tenantReducer;
  const { showPromoRewardsMessage = false } = componentOptions?.web?.cartPage;
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { cartItems, timeBasedCetegory, timeBasedAlertModalData } = userOrderState;
  useShowToastMsg(removedAddOnItems);
  const dispositionNew = isEmptyEvery(userOrderState?.dispositionNew)
    ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_NEW))
    : userOrderState?.dispositionNew;
  const params = useMemo(() => {
    return {
      dispositionType:
        dispositionNew && dispositionNew.type
          ? getDispositionTypeOnAPIFormat(dispositionNew.type)
          : getDispositionTypeOnAPIFormat(tenantReducer.authoredContent?.defaultdisposition),
    };
  }, [dispositionNew, tenantReducer]);
  const dynamicMenuAlertData = useMemo(() => {
    if (!isEmpty(timeBasedAlertModalData)) {
      const alertDetails = {
        isBrowseMenuOrReviewOrderCTAClicked: timeBasedAlertModalData?.isBrowseMenuOrReviewOrderCTAClicked,
        title: timeBasedAlertModalData?.title,
        isCloseButtonClicked: timeBasedAlertModalData?.isCloseButtonClicked,
      };
      localStorage.setItem(START_ORDER_CONSTANTS?.RECENT_DYNAMIC_MENU_ALERT_DETAILS, JSON.stringify(alertDetails));
      return alertDetails;
    } else {
      return getObjectFromLocalStorage(START_ORDER_CONSTANTS?.RECENT_DYNAMIC_MENU_ALERT_DETAILS);
    }
  }, [timeBasedAlertModalData]);
  const { dispositionType } = params;
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    itemQuantityHandler,
    itemRemoveHandler,
    itemEditHandler,
    addMoreMenuHandler,
    itemCustomiseHandler,
    navigateToPromos,
    promosRemoveHandler,
    itemAllRemoveAction,
  } = FoodItemListHandlers(
    cartSummary,
    tenantId,
    cartItems,
    productMapByItemId,
    userOrderStateDispatch,
    dispatch,
    history,
    [],
    userType,
    currencyShortName,
  );
  const computePrice = price => price && Number(price)?.toFixed(2);
  const getCouponCode = foodItemId => {
    const filterPromoItem =
      promosApplied &&
      discountAmounts?.filter(item => {
        let findPromoItem = item?.itemPromo?.some(promo => promo?.itemId === foodItemId);
        if (findPromoItem) {
          return true;
        }
        return false;
      });
    if (filterPromoItem?.length > 0) {
      return filterPromoItem?.[0]?.couponCode;
    }
    return false;
    //return filterPromoItem;
  };

  const getQuantityPriceHandler = (item, isAddedFromCoupon, paymentDiscountAmountData) => (
    <>
      <div
        className={`cart-food-quantity-price ${getTernaryValue(
          item?.modifiers?.length === 0,
          'empty-mods-quantity-price',
          '',
        )} 
      ${isAddedFromCoupon && 'coupon-item-quantity-price'}`}
      >
     {getQuantityModifier(item, ITEM_QUANTITY, QUANTITY_ACTION, itemQuantityHandler, maxItemCountPerLineItem, paymentDiscountAmountData)}
        {!item?.toRemove ? (
          <div className='cart-food-price'>
            {currencySymbol}
            {computePrice(item?.cartPrice)}
          </div>
        ) : null}
      </div>
      
    </>
  );
  const promosApplied = discountAmounts?.length > 0;
  const [showConfirmationModel, setConfirmationModel] = useState(false);
  const [removableItem, setRemovableItem] = useState({});

  const handleAlertClose = () => {
    setConfirmationModel(false);
  };
  const setModel = item => {
    setConfirmationModel(true);
    setRemovableItem(item);
  };
  const confirmHandler = item => {
    setConfirmationModel(false);
    if (removableItem?.foodItemId || item?.foodItemId) {
      itemRemoveHandler(removableItem);
      const couponCode = getCouponCode(removableItem?.foodItemId);
      if (couponCode) {
        // only testing and demo purpose, if it's work then we will make it to synchronous call after discusstion with RNA
        setTimeout(() => {
          promosRemoveHandler(couponCode);
        }, 1000);
      }
    } else if (removableItem?.itemPromo?.length || item?.itemPromo?.length) {
      promosRemoveHandler(removableItem?.couponCode, findPromoProductItem(removableItem, contentData));
    } else {
      promosRemoveHandler(removableItem?.couponCode);
    }
  };
  const getUnavailableItems = () => {
    const unavailableItems = timeBasedCetegory?.foodLinesItems?.filter(
      foodItem => foodItem?.item?.categoryUrl === timeBasedCetegory?.url && timeBasedCetegory?.isTimeExpired,
    );
    if (unavailableItems?.length) {
      let count = 0;
      const removeItem = () => {
        const item = unavailableItems[count];
        item.foodLineId = item?.id;
        itemRemoveHandler(item);
        count++;
        setTimeout(() => {
          if (count < unavailableItems?.length) {
            removeItem();
          }
        }, 500);
      };
      removeItem();
      toast.dark(
        <div className='img-text-div'>
          <span className={`notifyText notifyText-in`}>
            {translateWithI18Next(CART_PAGE_CONSTANTS?.TOAST_NOTIFICATION?.ITEM_REMOVED)}
          </span>
        </div>,
        {
          bodyClassName: 'toast-for-favorite',
          hideProgressBar: true,
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: true,
        },
      );
    }
  };
  return (
    <React.Fragment>
      <div className='cart-food-container' data-testid='cart-food-item-test'>
        <div className='back-to-menu-cart-page viewall-promos-cart-page'>
          <a data-testid='back-to-menu' onClick={() => addMoreMenuHandler(dispositionType)}>
            {translateWithI18Next(BACK_TO_MENU)}
          </a>
          <div className='view-all-text'>
            <span
              className='offersViewAll-link promosHeader-right-text'
              onClick={() => navigateToPromos()}
              data-testid='view-all-deals-handler'
            >
              {translateWithI18Next(VIEW_ALL_PROMOS)}
            </span>
            <ReactSVG className='promosViewAlldeals-arrow' src={ViewDetailsArrowBlack} />
          </div>
        </div>
        {timeBasedCetegory?.timebasedItemInCart &&
          timeBasedCetegory?.isTimeExpired &&
          (dynamicMenuAlertData?.isBrowseMenuOrReviewOrderCTAClicked ||
            (dynamicMenuAlertData?.title === START_ORDER_CONSTANTS?.CART_REVIEW_ORDER_MODAL &&
              dynamicMenuAlertData?.isCloseButtonClicked)) && (
            <div className='cart-food-item-container ItemUnavailable-remove-section'>
              <div className='cart-removeall-content-parent-container'>
                <div className='removeall-cart-text-container'>
                  <div className='cart-removeall-text-header'>{translateWithI18Next(REMOVE_ALL_UNAVAILABLE_TEXT)}</div>
                  <div className='cart-removeall-text-content'>{translateWithI18Next(UNAVAILABLE_ITEMS)}</div>
                </div>
                <ContainedButton
                  className='cart-removeall-button'
                  aria-label='Remove all products'
                  onClick={getUnavailableItems}
                  data-testid='remove-all-btn'
                >
                  {translateWithI18Next(REMOVE)}
                </ContainedButton>
              </div>
            </div>
          )}

        {checkIfStoreShutDown(storesWithStatus) && (
          <div className={`store-unavailale-cart-page`}>
            <div>
              <ImageComponent srcFile={IMAGE_PATH.Ellipse} className='cart-summary-error-icon' />
            </div>
            <span class='cart-summary-error-message'>{translateWithI18Next(CHECKOUT_UNAVAILABLE_AT_STORE)}</span>
          </div>
        )}
        <CartEditNotification contentData={contentData} />
        {promosApplied && showPromoRewardsMessage && (
          <CartPagePromosItem contentData={discountAmounts} setConfirmationModel={setModel} loggedIn={loggedIn} />
        )}
        <FoodItemListCard
          contentData={contentData}
          addHope={addHope}
          carryBag={carryBag}
          isMobile={isMobile}
          tenantReducer={tenantReducer}
          itemEditHandler={itemEditHandler}
          itemRemoveHandler={itemRemoveHandler}
          getQuantityPrice={getQuantityPriceHandler}
          categories={categories}
          flatResponse={flatResponse}
          itemCustomiseHandler={itemCustomiseHandler}
          dispositionType={dispositionType}
          promosApplied={promosApplied}
          disCountLinesItems={discountAmounts}
          setConfirmationModel={setModel}
          data-testid='food-item-card'
          isRemoveItemLoading={isRemoveItemLoading}
          timeBasedCetegory={timeBasedCetegory}
          timeBasedAlertModalData={!isEmpty(timeBasedAlertModalData) ? timeBasedAlertModalData : dynamicMenuAlertData}
          itemAllRemoveAction={itemAllRemoveAction} /* only for test case */
          discountAmounts={discountAmounts}
          productMapByItemId={productMapByItemId}
          paymentDiscountAmounts = {paymentDiscountAmounts}
        />

        {showConfirmationModel && (
          <AlertFormInsideModel
            data-testid='remove-promo-modal'
            handleClose={handleAlertClose}
            classNames='promos-rewards-warning-msg'
            CartAlertForm={
              <AlertForm
                splitTitle={{ MSGTXT1: `${translateWithI18Next(PROMO_REMOVE_CONFIRMATION)}` }}
                imageSrc={CartError}
                confirmButtonText={translateWithI18Next(YES_REMOVE)}
                cancelButtonText={translateWithI18Next(CANCEL)}
                confirmHandler={confirmHandler}
                cancelHandler={handleAlertClose}
                buttonContainerClass='deeplink-alert-btn-container alert-btn-container'
                data-testid='alert-form-modalId'
              />
            }
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default FoodItemList;
